__turbopack_context__.v({
  "Sidepanel": "Sidepanel-module-scss-module__FlJycW__Sidepanel",
  "closeIconButton": "Sidepanel-module-scss-module__FlJycW__closeIconButton",
  "content": "Sidepanel-module-scss-module__FlJycW__content",
  "header": "Sidepanel-module-scss-module__FlJycW__header",
});
